/**
 * T1 K2a — the status words item search reads as HISTORICAL: a row in one of them is the record
 * of finished or replaced work, not the current source. Type-agnostic like the closed counter it
 * extends; pinned against the seed both ways in `dmStaleStatus.test.ts` (api).
 */
import { DM_CLOSED_COUNT_STATES } from './dmLifecycleState.js';
/** Every closed-count word, plus dm.issue's settled-but-reopenable `resolved`. */
export const DM_STALE_STATUSES = [...DM_CLOSED_COUNT_STATES, 'resolved'];
/** Types stale through a closed PARENT too: an approved plan of a done wave is history (decision c7018 B). */
export const DM_STALE_BY_PARENT_TYPES = ['dm.plan'];
const STALE = new Set(DM_STALE_STATUSES);
const BY_PARENT = new Set(DM_STALE_BY_PARENT_TYPES);
/**
 * The one row rule; `dm.item.search` renders it in SQL from the same constants and checks each row against this.
 * `hasSupersededBy`: a `supersedes` edge points at the row — history whatever its own word (`dm.spec.get` `staleSpec`, c7028).
 */
export function isDmStaleRow(row) {
    return (row.hasSupersededBy ||
        STALE.has(row.status) ||
        (BY_PARENT.has(row.type) && row.parentStatus !== null && STALE.has(row.parentStatus)));
}
/**
 * A ranked search multiplies a stale row's lexical rank by this; an exact `#itemNo` or exact-title
 * query is exempt. Tuned on the probe corpus (`dmItemSearchStale.pg.test.ts`), never replaced by a
 * hard stale-last partition: `ts_rank`'s scale moves with the query, a factor keeps relevance.
 */
export const DM_STALE_RANK_PENALTY = 0.3;
//# sourceMappingURL=dmStaleStatus.js.map